// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".adImageListItem_3j1e6v-2wOpRxLB4zZRcFl{max-width:300px}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/ads/styles.scss"],"names":[],"mappings":"AAAA,wCACE,eAAgB","file":"styles.scss","sourcesContent":[":local(.adImageListItem) {\n  max-width: 300px;\n}\n"]}]);
// Exports
exports.locals = {
	"adImageListItem": "adImageListItem_3j1e6v-2wOpRxLB4zZRcFl"
};
module.exports = exports;
